<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main collect_main" v-infinite-scroll="getData" infinite-scroll-delay="200" infinite-scroll-distance="100">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <div class="filter">
            <el-row :gutter="10">
              <el-col :span="4">
                <h4>我收藏的效果图</h4>
              </el-col>
              <el-col :span="6" v-if="global.type == 'client'">
                <div class="grid-content">
                  <el-input
                    placeholder="请输入内容"
                    prefix-icon="el-icon-search"
                    @change="onChange"
                    v-model="searchInput">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="12" v-if="global.type == 'manage'">
                <el-select v-model="customerValue" placeholder="请选择" @change="customerChange">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option
                    v-for="item in customerData"
                    :key="item.client_id"
                    :label="item.client_name"
                    :value="item.client_name">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in renderData" :key="item.effect_id" class="clientBox">
            <el-divider content-position="left">{{ item.createtime }}</el-divider>
            <!-- <el-divider></el-divider> -->
            <div class="effectBox">
              <div class="item" v-for="(itemM, indexM) in item.effect_data" :key="indexM">
                <div class="media" @click="toDetail(index,indexM)">
                  <img v-if="itemM.file_type == 0" :src="itemM.file_url" alt="">
                  <video v-if="itemM.file_type == 1" :src="itemM.file_url" :poster="itemM.photo_url"></video>
                  <div v-if="itemM.file_type == 1" class="play"><img src="../../assets/ico_play.png" alt=""></div>
                </div>
                <div class="spaceName">{{ itemM.space_type }}</div>
                <div class="favorite" @click="toFavorite(index,indexM)"><i class="el-icon-star-on"></i>取消收藏</div>
              </div>
            </div>
          </div>
          <div class="clientBox" v-if="renderData.length <= 0">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
        <el-dialog
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true"
          :closeDetail="closeDetail">
          <div class="img" v-if="media_type != -1">
            <img v-if="media_type == 0" :src="media_url" alt="">
            <video v-if="media_type == 1" :src="media_url" :poster="media_photo" alt="" controls></video>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
const imgDemo = require('../../assets/pic_xgt.jpg')

function processRenderData(renderData, newData) {
  const _render = JSON.parse(JSON.stringify(renderData));
  newData.forEach(current => {
    const {
      effect_favorite_id,
      file_type,
      file_url,
      photo_url,
      createtime,
      space_type
    } = current;

    // console.log('current', current)

    // 1. 查找或创建客户分组
    let dateGroup = _render.find(c => c.createtime === createtime);
    if (!dateGroup) {
      dateGroup = {
        createtime,
        effect_data: []
      };
      _render.push(dateGroup);
    }

    // 2. 查找或创建空间分组
    let effectGroup = dateGroup.effect_data.find(s => s.effect_favorite_id === effect_favorite_id);
    if (!effectGroup) {
      effectGroup = {
        effect_favorite_id,
        file_type,
        file_url,
        photo_url,
        space_type
      };
      dateGroup.effect_data.push(effectGroup);
    }

    // clientGroup.space_data.push(spaceGroup);
    console.log(_render)

  }, []);
  return _render;
}

let _ajaxType = 0

export default {
  name: 'EffectHistory',
  components: {},
  data() {
    return {
      title: '',
      searchInput: '',
      customerData: [],
      customerValue: '全部',
      renderData: [],
      page: 0,
      pagesize: 10,
      allpage: 0,
      dialogVisit: false,
      media_url: '',
      media_photo: '',
      media_type: -1
    }
  },
  created() {
    let _title = '效果生成历史'
    if(this.global.type == 'client'){
      _title = this.global.clientName
    }
    this.title = _title
    // const _render = processRenderData([], renderData)
    // this.renderData = _render

    // console.log('结果：', _render)
    _ajaxType = 0
    this.page = 0
    this.allpage = 0
    this.getData()
    this.getCustomer()
  },
  methods: {
    getData() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _url = "/api/?mod=effect_favorite"
        let _clientData = {
          client_id: this.global.clientId,
          page: _page + 1,
          pagesize: this.pagesize,
          keyword: this.searchInput
        }
        // console.log(this.axios)
        this.axios.post(_url, _clientData).then(json => {
          _ajaxType = 0
          // 获取
          let _data = json.data.data
          console.log("effectData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            let _result = processRenderData(this.renderData, _data.result)
            console.log('result', _result)
            this.renderData = _result
          }
          console.log(json.data);
        })
      }
    },
    getCustomer() {
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("customerData", _data);
        if (json.data.errcode == 0) {
          // let _client = _data.result[0].client_name
          // if(this.global.type == 'manage' && this.global.clientName != ''){
          //   _client = this.global.clientName
          // }
          // this.customerValue = _client
          this.customerData = _data.result
          // this.getSpace()
        }
        console.log(json.data);
      })
    },
    customerChange(e) {
      console.log('customerChange', e)
      let nowCustomer = {
        client_id: '',
        client_name: ''
      };
      if(e != '全部'){
        nowCustomer = this.customerData.find(c => c.client_name === e)
      }
      this.global.clientId = nowCustomer.client_id
      this.global.clientName = nowCustomer.client_name
      this.page = 0
      this.allpage = 0
      this.renderData = []
      this.getData()
    },
    toDetail(cur, curM) {
      let _render = this.renderData
      this.media_url = _render[cur].effect_data[curM].file_url
      let _type = _render[cur].effect_data[curM].file_type
      if(_type == 1){
        this.media_photo = _render[cur].effect_data[curM].photo_url
      }
      this.media_type = _type
      this.dialogVisit = true
    },
    onChange(e) {
      console.log(e)
    },
    toFavorite(cur, curM) {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _render = [...this.renderData]
      let _url = "/api/?mod=effect_favorite&action=cancel"
      let _id = _render[cur].effect_data[curM].effect_favorite_id
      let _favoriteData = {
        effect_favorite_id: _id
      }
      console.log(_render)
      this.axios.post(_url, _favoriteData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("favoriteData", _data);
        if (json.data.errcode == 0) {
          console.log('1', _render[cur].effect_data.length)
          if(_render[cur].effect_data.length > 1){
            _render[cur].effect_data.splice(curM, 1)
          }
          if(_render[cur].effect_data.length <= 1){
            _render.splice(cur, 1)
          }
          this.renderData = _render
          this.$message({
            message: '取消收藏成功',
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    closeDetail(e) {
      this.media_type = -1
      this.dialogVisit = false
      this.media_url = ''
      this.media_photo = ''
      e()
    },
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}

.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;

  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;

    .filter {
      margin-bottom: 20px;

      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        background: #fff;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }

      .el-button {
        width: 100%;
      }
    }

    .renderLabel {
      width: 100px;
    }

    .effectBox {
      margin-top: 20px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      .item {
        position: relative;
        .media {
          position: relative;
          width: 100%;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          font-size: 0;
          img {
            width: 100%;
            aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
            object-fit: cover;
          }
          video {
            position: relative;
            width: 100%;
            height: 100%;
            background: #000;
            z-index: 1000;
          }
          .play {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: calc(100% - 20px);
            padding: 30%;
            /* background: url(../../assets/ico_play.png) no-repeat;
            background-position: center center;
            background-size: 60%; */
            box-sizing: border-box;
            z-index: 1001;
            img {
              width: 100%;
              height: 100%;
              // aspect-ratio: 1 / 1;
              object-fit: contain;
            }
          }
        }
        .spaceName {
          padding-left: 10px;
          font-size: 14px;
          color: rgba(10, 10, 10, 1);
          line-height: 30px;
        }
        .favorite {
          position: absolute;
          bottom: 0;
          right: 10px;
          font-size: 14px;
          color: rgba(10, 10, 10, 1);
          line-height: 30px;
        }

      }

      &:first-child {
        margin-top: 0;
      }
    }
  }
}.el-dialog {
  .img {
    font-size: 0;
    text-align: center;
    img,
    video {
      // max-width: 100%;
      // max-height: 70vh;
      // object-fit: contain;
      max-width: 80vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Effect/Collect.vue